module.exports = {"share":{"rowsPerPage":"Rows","rangeSeparator":"of","noData":"No Data","addWork":"Add Work","startDate":"Start Date","dueDate":"Due Date","dateRang":"Date Rang","updateBy":"Update By","lastUpdateBy":"Last Update By","updateDate":"Update Date","activity":"Activity","remark":"Remark","searchOneDeive":"Search OneDrive File","fileName":"File Name","action":"Action","download":"Download","createDate":"Create Date"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/share.json
// module id = 927
// module chunks = 108